// Display names only. The stored role IDs and permission rules stay unchanged.
const INTERNAL_ROLE_LABELS = {
  'maintenance-l1': 'Employee',
  'maintenance-l2': 'Manager',
  'maintenance-l3': 'Admin',
  maintenance: 'Admin',
};

export function internalRoleLabel(role) {
  return INTERNAL_ROLE_LABELS[String(role || '').trim().toLowerCase()] || '';
}
